import { createIcon } from "../create-icon"

export const EyeOnIcon = createIcon({
  title: "EyeOnIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3C4.19 3 2.122 5.903 1.353 7.285c-.25.45-.25.98 0 1.43C2.122 10.097 4.19 13 8 13s5.878-2.903 6.647-4.285c.25-.45.25-.98 0-1.43C13.878 5.903 11.81 3 8 3zm3 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM9.414 9.414a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828z"
      fill="currentColor"
    />
  ),
})
